module.exports = __webpack_public_path__ + "static/img/img09.164f072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv029/sp/img09.png
// module id = qhH2
// module chunks = 0